import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchCreateTask } from './actions/fetch-create-task';
import { ICreateTaskState } from './types/CreateTask-interface';

const initialState: ICreateTaskState = {
    isLoadingCreateTask: false,
    errorCreateTask: [],
    lastFetchTime: null,
    CreateTaskID: "",
    CreateTaskNumber: "",
};

export const CreateTask = createSlice({
    name: 'CreateTask',
    initialState,
    reducers: {
        resetCreateTask: (state) => {
            state.isLoadingCreateTask = false;
            state.errorCreateTask = [];
            state.lastFetchTime = null;
            state.CreateTaskID = "";
            state.CreateTaskNumber = "";
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCreateTask.pending, (state) => {
                state.isLoadingCreateTask = true;
            })
            .addCase(fetchCreateTask.fulfilled, (state, action: PayloadAction<{ taskID: string, fetchTime: number, taskNumber: string }>) => {
                state.isLoadingCreateTask = false;
                state.errorCreateTask = [];
                state.lastFetchTime = action.payload.fetchTime;
                state.CreateTaskID = action.payload.taskID;
                state.CreateTaskNumber = action.payload.taskNumber;
            })
            .addCase(fetchCreateTask.rejected, (state, action) => {
                state.isLoadingCreateTask = false;
                state.errorCreateTask = action.payload as string[];
                state.CreateTaskID = "";
                state.CreateTaskNumber = "";
            });
    },
});

export const { resetCreateTask } = CreateTask.actions;
export default CreateTask.reducer;